module.exports = {
  SET_AID_CONNECT_ID: 'set_aid_connect_id',
  SET_AID_CONNECT_STATUS: 'set_aid_connect_status',
};
